import api from './client';

export const listTeams = async () => {
  const { data } = await api.get('/teams');
  return data;
};

export const getTeam = async (teamId) => {
  const { data } = await api.get(`/teams/${teamId}`);
  return data;
};

export const createTeamWithAccount = async (teamData) => {
  const { data } = await api.post('/teams/create-with-account', teamData);
  return data;
};

export const createTeam = async (payload) => {
  const { data } = await api.post('/teams', payload);
  return data;
};

export const updateTeam = async (teamId, payload) => {
  const { data } = await api.patch(`/teams/${teamId}`, payload);
  return data;
};

export const deleteTeam = async (teamId) => {
  const { data } = await api.delete(`/teams/${teamId}`);
  return data;
};

export const getTeamVault = async (teamId) => {
  const { data } = await api.get(`/teams/${teamId}/vault`);
  return data;
};

export const inviteTeamMember = async (teamId, payload) => {
  const { data } = await api.post(`/teams/${teamId}/members/invite`, payload);
  return data;
};

export const getInvitations = async () => {
  const { data } = await api.get('/teams/invitations');
  return data;
};

export const getTeamInvitations = async (teamId) => {
  const { data } = await api.get(`/teams/${teamId}/invitations`);
  return data;
};

export const acceptTeamInvitation = async (invitationId) => {
  const { data } = await api.post(`/teams/invitations/${invitationId}/accept`);
  return data;
};

export const rejectTeamInvitation = async (invitationId) => {
  const { data } = await api.post(`/teams/invitations/${invitationId}/reject`);
  return data;
};

export const cancelTeamInvitation = async (invitationId) => {
  const { data } = await api.post(`/teams/invitations/${invitationId}/cancel`);
  return data;
};

export const resendTeamInvitation = async (invitationId) => {
  const { data } = await api.post(`/teams/invitations/${invitationId}/resend`);
  return data;
};

export const updateTeamMember = async (teamId, memberId, payload) => {
  const { data } = await api.patch(`/teams/${teamId}/members/${memberId}`, payload);
  return data;
};

export const removeTeamMember = async (teamId, memberId) => {
  const { data } = await api.delete(`/teams/${teamId}/members/${memberId}`);
  return data;
};

export const leaveTeam = async (teamId) => {
  const { data } = await api.post(`/teams/${teamId}/leave`);
  return data;
};

export const updateTeamPermissions = async (teamId, permissions) => {
  const { data } = await api.patch(`/teams/${teamId}/permissions`, permissions);
  return data;
};

// export const getTeamVault = async (teamId) => {
//   const { data } = await api.get(`/teams/${teamId}/vault`);
//   return data;
// };

export const getTeamCategories = async (teamId) => {
  const { data } = await api.get(`/teams/${teamId}/categories`);
  return data;
};

export const getTeamActivity = async (teamId) => {
  const { data } = await api.get(`/teams/${teamId}/activity`);
  return data;
};
